import { FormattedMessage, defineMessage } from 'react-intl';

import { Button } from 'atoms/buttons/Button';
import { Vertical } from 'atoms/layout/flex';
import { BodyM } from 'atoms/typography';
import { LanguageSwitcher } from 'components/user/LanguageSwitcher';

import { SettingsSection } from '../SettingsSection';

const message = defineMessage({
  id: 'Settings.preferredLanguage.title',
  defaultMessage: 'Language',
});

export const PreferredLanguage = () => {
  return (
    <SettingsSection title={message}>
      <Vertical>
        <BodyM>
          <FormattedMessage
            id="Settings.preferredLanguage.label"
            defaultMessage="Preferred language"
          />
        </BodyM>
        <LanguageSwitcher
          renderButton={({ content, ...props }) => (
            <Button {...props} size="small" color="tertiary">
              {content}
            </Button>
          )}
        />
      </Vertical>
    </SettingsSection>
  );
};
